module.exports = __webpack_public_path__ + "img/check-icon.d86382cf.svg";